import 'hammerjs';

/* Script for the list of available decks */

export class DeckList {
  constructor(element) {
    this.element = element;
    this.cards = element.querySelectorAll('.awk-slide-item');
    this.announce = document.querySelector('.awk-deck-list__announce');
    this.cardCount = this.cards.length;
    this.current = 0;
    this.isMobile = false;

    this.nextButton = document.getElementById('next');
    this.prevButton = document.getElementById('prev');

    this.initPagination();
    this.initNavigationHandler();
    this.updateNavigation(this.current);
    this.initDraggable();
    this.setAccessibleAttributes();
    this.initResizeObserver();
    this.updateAnnounce(this.current);
  }

  updateAnnounce(position) {
    this.announce.innerText =
      position === 0
        ? `Intro Card. There are ${this.cardCount} decks available.`
        : `Deck ${position} out of ${this.cardCount}`;
  }

  setAccessibleAttributes() {
    if (this.isMobile) {
      document
        .querySelectorAll('.awk-slide-item:not(.current)')
        .forEach((card) => {
          card.setAttribute('aria-hidden', true);
          card.setAttribute('inert', true);
        });
    } else {
      document.querySelectorAll('.awk-slide-item').forEach((card) => {
        card.removeAttribute('aria-hidden');
        card.removeAttribute('inert');
      });
    }
  }

  initResizeObserver() {
    const deckListElement = document.querySelector('.awk-deck-list');

    if (!deckListElement) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      this.isMobile = window.matchMedia('(max-width: 782px)').matches;
      this.setAccessibleAttributes();
    });

    resizeObserver.observe(deckListElement);
  }

  updateCurrent(delta) {
    const nextCurrent = this.current + delta;

    if (nextCurrent < 0 || nextCurrent > this.cardCount - 1) {
      return;
    }

    this.updateNavigation(nextCurrent);
    this.updatePagination(nextCurrent);
    this.updateCurrentDeck(this.current, nextCurrent, delta);

    this.current += delta;
    this.updateAnnounce(this.current);
    this.setAccessibleAttributes();
  }

  initNavigationHandler() {
    this.element.querySelectorAll('.awk-deck__arrow').forEach((arrow) => {
      arrow.addEventListener('click', (event) => {
        const delta = parseInt(event.currentTarget.dataset.delta, 10);
        this.updateCurrent(delta);
      });
    });
  }

  updateNavigation(current) {
    if (current === 0) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (current >= this.cards.length - 1) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  updateCurrentDeck(current, next, delta) {
    this.cards[current].classList.remove('current');
    if (delta < 0) {
      this.cards[current].classList.add('hidden');
    }

    this.cards[next].classList.remove('hidden');
    this.cards[next].classList.add('current');

    this.cards[next].removeAttribute('inert');
    this.cards[next].removeAttribute('aria-hidden');

    this.setAccessibleAttributes();
  }

  initPagination() {
    const paginationElement = this.element.querySelector(
      '.awk-deck__pagination',
    );

    if (!paginationElement || !this.cardCount) {
      return;
    }

    new Array(this.cards.length).fill(0).map((i, index) => {
      const item = document.createElement('div');

      item.classList.add('awk-deck__pagination-item');
      item.dataset.position = `${index}`;

      paginationElement.appendChild(item);

      return item;
    });

    this.element
      .querySelector(
        `.awk-deck__pagination-item[data-position="${this.current}"]`,
      )
      .classList.add('current');
  }

  updatePagination(nextCurrent) {
    this.element
      .querySelector(`.awk-deck__pagination-item.current`)
      .classList.remove('current');

    this.element
      .querySelector(
        `.awk-deck__pagination-item[data-position="${nextCurrent}"]`,
      )
      .classList.add('current');
  }

  initDraggable() {
    const hammer = new Hammer(this.element);

    hammer.on('swipeleft', (event) => {
      event.preventDefault = true;

      this.updateCurrent(1);
    });

    hammer.on('swiperight', (event) => {
      event.preventDefault = true;

      this.updateCurrent(-1);
    });
  }
}
